<template>
  <div id="hashtagsBar">
    <div class="row bg-white rounded-t-lg align-items-center " id="hashtags">
      <div class="col-12 col-sm-9 col-lg-10 " id="hashtagsWrapper">
        <div
            v-if="hashtags !== null && hashtags !== undefined && hashtags.length > 0"
            dir="ltr">
          <carousel
              :autoplay="true"
              :autoplayTimeout="6000"
              :dots="false"
              :loop="false"
              :margin="5"
              :nav="false"
              :navText="navText"
              :responsive="{0:{items:3,margin:5},570:{items:5,margin:5},600:{items:4},700:{items:5}
                                                ,900:{items:7},1100:{items:10},1200:{items:12}}"

              class="py-1 text-center">
            <router-link v-for="item in hashtags"
                         :key="item.HashTagID"
                         class="trend-field"
                         :to="{path:'Trends',query:{ID:item.HashTagID,Content:item.Content}}">
              {{ item.Content }}#
            </router-link>
          </carousel>
        </div>
      </div>
      <router-link v-if="currentPage === '/Home'" class="col-4 pr-0 col-sm-3 col-lg-2 text-left d-inline-block "
                   to="Trends">
        ترندهای بیشتر <i class="fa-solid fa-arrow-left transform-icon pr-1"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";


export default {
  name: "HashtagsBar",
  components: {
    carousel,
  },
  data: () => ({
    hashtagsLoading: true,
    hashtags: [],
    navText: ['<i class="fa-solid fa-circle-chevron-left" aria-hidden="true"></i>'],
    currentPage: null,
    pageTitle: "ترندها"

  }),
  metaInfo() {
    return {
      title: "ایوان خانه - " + this.pageTitle,
    };
  },
  watch: {
    '$route.query.ID'() {
      this.pageTitle = "#" +
          (this.$route.query.Content === undefined ? "هشتگ" : this.$route.query.Content);
    }
  },
  mounted() {
    this.getHashtags()
    this.currentPage = this.$router.currentRoute.path
  },
  methods: {
    getHashtags() {

      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/GetHashTags", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            if (this.currentPage === '/Home' || this.currentPage === '/') {
              this.hashtags = json.filter(x => x.IsPopular === true)
              document.getElementById('hashtags').classList.add('fix-to-bottom')
              document.getElementById('hashtagsWrapper').classList.remove('col-12')
              document.getElementById('hashtagsWrapper').classList.add('col-8')
            } else {
              this.hashtags = json.filter(x => x.IsPopular === true)
            }
            this.hashtagsLoading = false;

            if (this.$route.query.ID !== undefined) {
              let selectedHashTag = json.filter(x => x.HashTagID === this.$route.query.ID)[0];
              if (selectedHashTag !== undefined) {
                this.pageTitle = "#" + (selectedHashTag.Content);
              }
            }

          })
          .catch(error => console.log('error', error));
    },
  }

}
</script>

<style scoped>

</style>
